import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { type ReactNode, useEffect, useState } from "react";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { bindTheme } from "@/stores/theme";

// Query defaults copied from connect-v2: short stale time, one retry, no
// refetch on focus (offline-first data lives in Dexie anyway).
function createQueryClient() {
	return new QueryClient({
		defaultOptions: {
			queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
		},
	});
}

export function Providers({ children }: { children: ReactNode }) {
	const [queryClient] = useState(createQueryClient);

	useEffect(() => bindTheme(), []);

	return (
		<QueryClientProvider client={queryClient}>
			<TooltipProvider delayDuration={300}>
				{children}
				<Toaster position="top-center" closeButton />
			</TooltipProvider>
		</QueryClientProvider>
	);
}
